import {
  slide_to, slide_from, slide_down, slide_up, slide_in, slide_out, push_down,
  push_up, collection, properties,
}
  from './animation_types.js';
export default class animator {
  constructor() {
    this.animationQueue = [];
    this.animationQueueIndex = 0;
    this.animationLock = false;

    this.processAnimationQueue = this.processAnimationQueue.bind(this);
    this.performAnimation = this.performAnimation.bind(this);
    this.propertiesBase = this.propertiesBase.bind(this);
    this.bounceAmount = 20;
  }

  addAnimation(animation, insert) {
    if (this.animationLock) {
      return false;
    }
    if (insert) {
      this.animationQueue.splice(0, 0, animation);
    }
    else {
      this.animationQueue.push(animation);
    }
    return true;
  }

  addCollection(collectionValues, insert) {
    if (this.animationLock || (collectionValues && collectionValues.length == undefined)) {
      return false;
    }

    let coll = { type: collection, collectionValues: collectionValues };
    if (insert) {
      this.animationQueue.splice(0, 0, coll);
    }
    else {
      this.animationQueue.push(coll);
    }
    return true;
  }

  createPropertyAnimation(id, duration, addProperties, geometry) {
    let animation = {
      type: properties, id: id, duration: duration ? duration : 500, properties: addProperties,
      geometry: geometry,
    };
    return animation;
  }

  createAnimation(type, id, duration, bounce, startParamValue, endParamValue, secondaryId) {
    return {
      type: type, id: id, duration: duration ? duration : 500, bounce: bounce, startParamValue: startParamValue,
      endParamValue: endParamValue, secondaryId: secondaryId,
    };
  }

  handleProperty(ani, property, key, paramProperty, timedIncrementer) {
    let allDone = true;
    let byte1 = 0;
    let byte2 = 0;
    let byte3 = 0;
    if (property && paramProperty && ani.geometry) {
      property = ani.geometry(paramProperty, property, key);
    }
    else if (key.toLowerCase().indexOf('color') >= 0) {
      byte1 = property.currentVal & 0xff;
      byte2 = (property.currentVal & 0xff00) >> 8;
      byte3 = (property.currentVal & 0xff0000) >> 16;
      const incrementer = timedIncrementer >= 1 ? timedIncrementer : property.incrementer < 1 ? 1 : property.incrementer;
      byte1 += incrementer;
      byte2 += incrementer;
      byte3 += incrementer;
      property.currentVal = Math.min(255, byte1) | (Math.min(255, byte2) << 8) | (Math.min(255, byte3) << 16);
    }
    else if (timedIncrementer > 0 || timedIncrementer < 0) {
      if (property.endVal > property.startVal) {
        property.currentVal = Math.min(property.endVal, property.currentVal + timedIncrementer);
      }
      else {
        property.currentVal = Math.max(property.endVal, property.currentVal + timedIncrementer);
      }
    }
    else {
      if (property.endVal > property.startVal) {
        property.currentVal = Math.min(property.endVal, property.currentVal + property.incrementer);
      }
      else {
        property.currentVal = Math.max(property.endVal, property.currentVal + property.incrementer);
      }
    }
    let suffix = 0;
    if (key == 'verticalScroll') {
      ani.element.scrollTo(0, property.currentVal);
    }
    else if (key == 'horizontalScroll') {
      ani.element.scrollTo(property.currentVal, 0);
    }
    else {
      if (key.indexOf('margin') >= 0) {
        suffix = 'px';
      }
      else if (key.indexOf('rotate') >= 0) {
        if (key == 'rotateX') {
          ani.element.style['transform'] = 'rotate3D(1, 0, 0, ' + property.currentVal + 'deg)';
        }
        else if (key == 'rotateY') {
          ani.element.style['transform'] = 'rotate3D(0, 1, 0, ' + property.currentVal + 'deg)';
        }
        else if (key == 'rotateZ') {
          ani.element.style['transform'] = 'rotate3D(0, 0, 1, ' + property.currentVal + 'deg)';
        }
        else if (key == 'rotateXY') {
          ani.element.style['transform'] = 'rotate3D(1, 1, .45, ' + property.currentVal + 'deg)';
        }
        else if (key == 'rotateXZ') {
          ani.element.style['transform'] = 'rotate3D(1, .45, 1, ' + property.currentVal + 'deg)';
        }
        else if (key == 'rotateYZ') {
          ani.element.style['transform'] = 'rotate3D(.45, 1, 1, ' + property.currentVal + 'deg)';
        }
        else if (key == 'rotateXYX') {
          ani.element.style['transform'] = 'rotate3D(1, 1, 1, ' + property.currentVal + 'deg)';
        }
        if (timedIncrementer > 0) {
          if (property.currentVal < property.endVal) {
            allDone = false;
          }
        }
        else if (timedIncrementer < 0) {
          if (property.currentVal > property.endVal) {
            allDone = false;
          }
        }
        if (property.incrementer > 0) {
          if (property.currentVal < property.endVal) {
            allDone = false;
          }
        }
        else if (property.incrementer < 0) {
          if (property.currentVal > property.endVal) {
            allDone = false;
          }
        }
        return allDone;
      }
      else {
        if (property.usePercent) {
          suffix = '%';
        }
        else {
          switch (key) {
          case 'left':
            suffix = 'px';
            break;
          case 'top':
            suffix = 'px';
            break;
          case 'width':
            suffix = 'px';
            break;
          case 'height':
            suffix = 'px';
            break;
          case 'bottom':
            suffix = 'px';
            break;
          case 'right':
            suffix = 'px';  
            break;
          default:
            break;
          }
        }
      }
      if (key.toLowerCase().indexOf('color') >= 0) {
        const roundedValue = property.currentVal;
        let hex = roundedValue.toString(16);
        while (hex.length < 6) {
          hex = '0' + hex;
        }
        hex = '#' + hex;
        ani.element.style[key] = hex;
      }
      else {
        ani.element.style[key] = property.currentVal + suffix;
      }
    }
    if (paramProperty) {
      if (paramProperty.incrementer < 0 && paramProperty.currentVal > paramProperty.endVal) {
        allDone = false;
      }
      else if (paramProperty.incrementer > 0 && paramProperty.currentVal < paramProperty.endVal) {
        allDone = false;
      }
    }
    else if (key.toLowerCase().indexOf('color') >= 0) {
      if (byte1 < property.endVal || byte2 < property.endVal || byte3 <= property.endVal) {
        allDone = false;
      }
    }
    else {
      if (timedIncrementer > 0) {
        if (property.currentVal < property.endVal) {
          allDone = false;
        }
      }
      else if (timedIncrementer < 0) {
        if (property.currentVal > property.endVal) {
          allDone = false;
        }
      }
      else if (property.incrementer > 0) {
        if (property.currentVal < property.endVal) {
          allDone = false;
        }
      }
      else if (property.incrementer < 0) {
        if (property.currentVal > property.endVal) {
          allDone = false;
        }
      }
    }
    return allDone;
  }

  propertiesBase(ani, onComplete, localTimeStemp, fromCollection, collectionTimeDiff) {
    let allDone = false;
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      ani.lastTime = newTime;
      allDone = true;
      if (ani.properties && !ani.inProcess) {
        ani.inProcess = true;
        let paramProperty = null;
        for (var key in ani.properties) {
          if (key) {
            let property = ani.properties[key];
            const timedIncrementer = property.incrementer *
              (collectionTimeDiff ? collectionTimeDiff : timeDiff);
            if (property.geometryType == 'param') {
              paramProperty = property;
              allDone = this.handleProperty(ani, property, key, null, timedIncrementer);
            }
            else if (property.geometryType == 'result') {
              allDone = this.handleProperty(ani, property, key, paramProperty, timedIncrementer);
            }
            else {
              allDone = this.handleProperty(ani, property, key, null, timedIncrementer);
            }
          }
        }
        ani.inProcess = false;
      }
      else {
        ani.inProcess = false;
      }
    }

    if (fromCollection) {
      return allDone;
    }
    else {
      if (!allDone) {
        window.requestAnimationFrame(timestamp => {
          this.propertiesBase(ani, onComplete, timestamp, fromCollection,
          collectionTimeDiff);
        });
      }
      else {
        this.processAnimationQueue(onComplete);
      }
    }
  }

  initializeProperties(ani) {
    let vals = { startVal: 0, endVal: 0 };
    if (ani.properties) {
      // set some options
      for (var key in ani.properties) {
        if (key) {
          let property = ani.properties[key];
          if (property.startVal == null || property.startVal == undefined) {
            let value = ani.element.style[key];
            if (value && value.indexOf && value.indexOf('px') >= 0) {
              value = value.replace('px', '');
              property.startVal = parseInt(value, 10);
            }
          }
          if (!property.endVal) {
            property.endVal = 0;
          }
          if (property.endVal.indexOf && property.endVal.indexOf('%') >= 0) {
            property.usePercent = true;
            property.endVal = parseInt(property.endVal.replace('%', ''), 10);
          }
          if (property.startVal < property.endVal) {
            vals.startVal = Math.min(property.startVal, vals.startVal);
            vals.endVal = Math.max(property.endVal, vals.endVal);
          }
          else {
            vals.startVal = Math.max(property.startVal, vals.startVal);
            vals.endVal = Math.min(property.endVal, vals.endVal);
          }
          property.currentVal = property.startVal;
          property.incrementer = property.geometryType == 'result' && property.incrementer ? property.incrementer : ((property.endVal - property.startVal) / ani.duration);
        }
      }
    }
    return vals;
  }

  properties(ani, onComplete) {
    if (ani.properties) {
      let _this = this;
      ani.element = document.getElementById(ani.id);
      if (!ani.element) {
        this.animationLock = false;
        this.processAnimationQueue(onComplete);
        return;
      }
      // if (ani.element.style["overflow-y"] != "hidden") {
      //   ani.saveOverflow = ani.element.style["overflow-y"]
      //   ani.element.style["overflow-y"] = "hidden"
      // }  

      this.initializeProperties(ani);

      ani.lastTime = new Date().getTime();
      window.requestAnimationFrame((timestamp) => this.propertiesBase(ani, onComplete, timestamp));
    }
  }

  slideToFromBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff) {
    let doneX = false;
    let doneY = false;
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      ani.lastTime = newTime;
      const timedPixXPerTime = ani.pixXPerTime  * (collectionTimeDiff ? collectionTimeDiff : timeDiff);
      const timedPixYPerTime = ani.pixYPerTime * (collectionTimeDiff ? collectionTimeDiff : timeDiff);

      if (ani.currentVal.left && ani.currentVal.top && ani.endParamValue.left &&
        ani.endParamValue.top) {
        ani.currentVal.left = timedPixXPerTime >= 0 ? Math.min(ani.currentVal.left + timedPixXPerTime, ani.endParamValue.left) :
          Math.max(ani.currentVal.left + timedPixXPerTime, ani.endParamValue.left);
        ani.currentVal.top = timedPixYPerTime >= 0 ? Math.min(ani.currentVal.top + timedPixYPerTime, ani.endParamValue.top) :
          Math.max(ani.currentVal.top + timedPixYPerTime, ani.endParamValue.top);
        ani.element.style.left = ani.currentVal.left + 'px';
        ani.element.style.top = ani.currentVal.top + 'px';

        if (timedPixXPerTime < 0 && ani.currentVal.left <= ani.endParamValue.left) {
          doneX = true;
        }
        else if (timedPixXPerTime >= 0 && ani.currentVal.left >= ani.endParamValue.left) {
          doneX = true;
        }
        if (timedPixYPerTime < 0 && ani.currentVal.top <= ani.endParamValue.top) {
          doneY = true;
        }
        else if (timedPixYPerTime >= 0 && ani.currentVal.top >= ani.endParamValue.top) {
          doneY = true;
        }
      }
      else {
        this.processAnimationQueue(onComplete);
      }
    }

    if (fromCollection) {
      return doneX && doneY;
    }
    else if (!doneX || !doneY) {
      window.requestAnimationFrame(timestamp => { this.slideToFromBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff); });
    }
    else {
      this.processAnimationQueue(onComplete);
    }
  }

  slideTo(ani, onComplete) {
    if (ani.startParamValue.left && ani.startParamValue.left &&
      ani.startParamValue.top && ani.startParamValue.top) {

      ani.pixXPerTime = (ani.endParamValue.left - ani.startParamValue.left) / ani.duration;
      ani.pixYPerTime = (ani.endParamValue.top - ani.startParamValue.top) / ani.duration;
      ani.currentVal = ani.startParamValue;
      ani.element = document.getElementById(ani.id);
      if (!ani.element) {
        this.animationLock = false;
        this.processAnimationQueue(onComplete);
        return;
      }

      // Make a copy of the element and hide the original

      const bodyElement = document.body;
      let copyElement = ani.element.cloneNode(true);
      copyElement.style.left = ani.currentVal.left + 'px';
      copyElement.style.top = ani.currentVal.top + 'px';
      ani.element.style.display = 'none';
      bodyElement.appendChild(copyElement);
      ani.element = copyElement;
      ani.lastTime = new Date().getTime();
      window.requestAnimationFrame((timestamp) => this.slideToFromBase(ani, onComplete, timestamp));
    }
  }

  slideFrom(ani, onComplete) {
    if (ani.startParamValue.left && ani.endParamValue.left &&
      ani.startParamValue.top && ani.endParamValue.top) {

      ani.currentVal = ani.startParamValue;

      let _this = this;
      ani.pixXPerTime = (ani.endParamValue.left - ani.startParamValue.left) / (ani.duration / 10);
      ani.pixYPerTime = (ani.endParamValue.top - ani.startParamValue.top) / (ani.duration / 10);
      ani.element = document.getElementById(ani.id);
      if (!ani.element) {
        this.animationLock = false;
        this.processAnimationQueue(onComplete);
        return;
      }

      // Make a copy of the element and hide the original

      const bodyElement = document.body;
      let copyElement = ani.element.cloneNode(true);
      copyElement.style.left = ani.startParamValue.left + 'px';
      copyElement.style.top = ani.startParamValue.top + 'px';
      bodyElement.appendChild(copyElement);
      ani.element = copyElement;
      ani.lastTime = new Date().getTime();
      window.requestAnimationFrame((timestamp) => this.slideToFromBase(ani, onComplete, timestamp));
    }
  }

  slideDownBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff) {
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      ani.lastTime = newTime;
      let timedPixPerTime = ani.pixelsPerTic * (collectionTimeDiff ? collectionTimeDiff : timeDiff);
      ani.currentVal = Math.min(ani.currentVal + timedPixPerTime, ani.endParamValue);
      if (ani.vertLine) {
        ani.vertLine.style.height = ani.currentVal + 'px';
      }
      ani.element.style.top = ani.currentVal + 'px';
    }

    if (fromCollection) {
      return ani.currentVal >= ani.endParamValue;
    }
    else if (ani.currentVal <= ani.endParamValue) {
      window.requestAnimationFrame(timestamp => { this.slideDownBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff); });
    }
    else {
      this.processAnimationQueue(onComplete);
    }
  }

  slideDown(ani, onComplete) {
    let pixelsPerTic = 1;
    let maxDistance = Math.abs(ani.startParamValue - ani.endParamValue);
    let maxTicsPerPixel = ani.duration / maxDistance;
    if (maxTicsPerPixel < 1) {
      pixelsPerTic = maxDistance / ani.duration;
      maxTicsPerPixel = 1;
    }
    else {
      maxTicsPerPixel = Math.ceil(maxTicsPerPixel);
    }

    ani.pixelsPerTic = pixelsPerTic;
    ani.element = document.getElementById(ani.id);
    ani.currentVal = ani.startParamValue;

    ani.vertLine = document.getElementById(ani.secondaryId);
    if (!ani.element) {
      this.animationLock = false;
      this.processAnimationQueue(onComplete);
      return;
    }
    if (ani.vertLine) {
      let lineHeight = ani.vertLine.style.height;
      let intHeight = parseInt(lineHeight.replace('px', ''), 0);
      intHeight += ani.pixelsPerTic;
      ani.vertLine.style.height = intHeight + 'px';
    }
    ani.lastTime = new Date().getTime();
    window.requestAnimationFrame((timestamp) => this.slideDownBase(ani, onComplete, timestamp));
  }

  slideUpBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff) {
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      let timedPixPerTime = ani.pixelsPerTic * (collectionTimeDiff ? collectionTimeDiff : timeDiff);
      ani.lastTime = newTime;
      ani.currentVal = Math.max(ani.currentVal - timedPixPerTime, ani.endParamValue);
      if (ani.vertLine) {
        ani.vertLine.style.height = ani.currentVal + 'px';
      }
      ani.element.style.top = ani.currentVal + 'px';

    }

    if (fromCollection) {
      return ani.currentVal <= ani.endParamValue;
    }
    else if (ani.currentVal <= ani.endParamValue) {
      window.requestAnimationFrame(timestamp => { this.slideUpBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff); });
    }
    else {
      this.processAnimationQueue(onComplete);
    }
  }

  slideUp(ani, onComplete) {
    let _this = this;
    ani.element = document.getElementById(ani.id);
    ani.vertLine = document.getElementById(ani.secondaryId);
    if (!ani.element) {
      this.animationLock = false;
      this.processAnimationQueue(onComplete);
      return;
    }
    let pixelsPerTic = 1;

    ani.currentVal = ani.startParamValue;

    let maxDistance = Math.abs(ani.startParamValue - ani.endParamValue);
    let maxTicsPerPixel = ani.duration / maxDistance;
    if (maxTicsPerPixel < 1) {
      pixelsPerTic = maxDistance / ani.duration;
      maxTicsPerPixel = 1;
    }
    else {
      maxTicsPerPixel = Math.ceil(maxTicsPerPixel);
    }

    ani.pixelsPerTic = pixelsPerTic;
    if (ani.vertLine) {
      let lineHeight = ani.vertLine.style.height;
      let intHeight = parseInt(lineHeight.replace('px', ''), 0);
      intHeight -= ani.pixelsPerTic;
      ani.vertLine.style.height = intHeight + 'px';
    }
    ani.lastTime = new Date().getTime();
    window.requestAnimationFrame(timestamp => { this.slideUpBase(ani, onComplete, timestamp); });
  }

  slideInBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff) {
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      let timedPixPerTime = ani.pixelsPerTic * (collectionTimeDiff ? collectionTimeDiff : timeDiff);
      ani.lastTime = newTime;
      ani.currentVal = Math.min(ani.currentVal + timedPixPerTime, ani.endParamValue);
      ani.element.style.left = (ani.currentVal) + 'px';
    }
    if (ani.currentVal < ani.endParamValue) {

      if (fromCollection) {
        return false;
      }
      else {
        window.requestAnimationFrame(timestamp => { this.slideInBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff); });
      }
    }
    else if(!fromCollection) {
      window.requestAnimationFrame(timestamp => { this.slideInBase(ani, onComplete, timestamp); });
    }
    else {
      return true;
    }
  }

  slideIn(ani, onComplete) {
    let _this = this;
    let pixelsPerTic = 1;
    let maxDistance = Math.abs(ani.currentVal - ani.endParamValue);
    let maxTicsPerPixel = ani.duration / maxDistance;

    ani.currentVal = ani.startParamValue;

    if (maxTicsPerPixel < 1) {
      pixelsPerTic = maxDistance / ani.duration;
      maxTicsPerPixel = 1;
    }
    else {
      maxTicsPerPixel = Math.ceil(maxTicsPerPixel);
    }

    ani.pixelsPerTic = pixelsPerTic;
    ani.element = document.getElementById(ani.id);
    if (!ani.element) {
      this.animationLock = false;
      this.processAnimationQueue(onComplete);
      return;
    }
    ani.lastTime = new Date().getTime();
    window.requestAnimationFrame(timestamp => { this.slideInBase(ani, onComplete, timestamp); });
  }

  slideOutBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff) {
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      let timedPixPerTime = ani.pixelsPerTic * (collectionTimeDiff ? collectionTimeDiff : timeDiff);
      ani.lastTime = newTime;
      ani.currentVal = Math.max(ani.currentVal - timedPixPerTime, ani.endParamValue);
      ani.element.style.left = (ani.currentVal) + 'px';
    }
    if (ani.currentVal > ani.endParamValue) {

      if (fromCollection) {
        return false;
      }
      else {
        window.requestAnimationFrame(timestamp => { this.slideOut(ani, onComplete, timestamp, fromCollection, collectionTimeDiff); });
      }
    }
    else if (!fromCollection) {
      window.requestAnimationFrame(timestamp => { this.slideOut(ani, onComplete, timestamp); });
    }
    else {
      return true;
    }
  }

  slideOut(ani, onComplete) {
    let _this = this;
    ani.element = document.getElementById(ani.id);
    if (!ani.element) {
      this.animationLock = false;
      this.processAnimationQueue(onComplete);
      return;
    }
    ani.currentVal = ani.startParamValue;

    let pixelsPerTic = 1;
    let maxDistance = Math.abs(ani.startParamValue - ani.endParamValue);
    let maxTicsPerPixel = ani.duration / maxDistance;
    if (maxTicsPerPixel < 1) {
      pixelsPerTic = maxDistance / ani.duration;
      maxTicsPerPixel = 1;
    }
    else {
      maxTicsPerPixel = Math.ceil(maxTicsPerPixel);
    }

    ani.pixelsPerTic = pixelsPerTic;
    ani.lastTime = new Date().getTime();
    window.requestAnimationFrame(timestamp => { this.slideOutBase(ani, onComplete, timestamp); });
  }

  pushDownBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff) {
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      let timedPixPerTime = ani.pixelsPerTic * (collectionTimeDiff ? collectionTimeDiff : timeDiff);
      ani.lastTime = newTime;
      ani.currentVal = Math.min(ani.currentVal + timedPixPerTime, ani.endParamValue);
      ani.element.style.height = (ani.currentVal) + 'px';
    }
    if (fromCollection) {
      return ani.currentVal > ani.endParamValue;
    }
    else if (ani.currentVal >= ani.endParamValue) {
      window.requestAnimationFrame(timestamp => { this.pushDownBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff); });
    }
    else {
      this.processAnimationQueue(onComplete);
    }
  }

  pushDown(ani, onComplete) {
    let _this = this;
    ani.element = document.getElementById(ani.id);
    if (!ani.element) {
      this.animationLock = false;
      this.processAnimationQueue(onComplete);
      return;
    }
    // if (ani.element.style["overflow-y"] != "hidden") {
    //   ani.saveOverflow = ani.element.style["overflow-y"]
    //   ani.element.style["overflow-y"] = "hidden"
    // }  
    ani.currentVal = ani.startParamValue;

    let pixelsPerTic = 1;
    let maxDistance = Math.abs(ani.startParamValue - ani.endParamValue);
    let maxTicsPerPixel = ani.duration / maxDistance;
    if (maxTicsPerPixel < 1) {
      pixelsPerTic = maxDistance / ani.duration;
      maxTicsPerPixel = 1;
    }
    else {
      maxTicsPerPixel = Math.ceil(maxTicsPerPixel);
    }

    ani.pixelsPerTic = pixelsPerTic;
    ani.lastTime = new Date().getTime();
    window.requestAnimationFrame(timestamp => { this.pushDownBase(ani, onComplete, timestamp); });
  }

  pushUpBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff) {
    const newTime = new Date().getTime();
    if (fromCollection || newTime - ani.lastTime >= 1) {
      const timeDiff = newTime - ani.lastTime;
      let timedPixPerTime = ani.pixelsPerTic * (collectionTimeDiff ? collectionTimeDiff : timeDiff);
      ani.lastTime = newTime;
      ani.currentVal = Math.max(ani.currentVal - timedPixPerTime, ani.endParamValue);
      ani.element.style.height = (ani.currentVal) + 'px';
    }
    if (fromCollection) {
      return ani.currentVal >= ani.endParamValue;
    }
    else if (ani.currentVal <= ani.endParamValue) {
      window.requestAnimationFrame(timestamp => { this.pushUpBase(ani, onComplete, timestamp, fromCollection, collectionTimeDiff); });
    }
    else {
      this.processAnimationQueue(onComplete);
    }
  }

  pushUp(ani, onComplete) {
    let _this = this;
    ani.element = document.getElementById(ani.id);
    if (!ani.element) {
      this.animationLock = false;
      this.processAnimationQueue(onComplete);
      return;
    }

    // if (ani.element.style["overflow-y"] != "hidden") {
    //   ani.saveOverflow = ani.element.style["overflow-y"]
    //   ani.element.style["overflow-y"] = "hidden"
    // }  

    ani.currentVal = ani.startParamValue;
    let pixelsPerTic = 1;
    let maxDistance = Math.abs(ani.startParamValue - ani.endParamValue);
    let maxTicsPerPixel = ani.duration / maxDistance;
    if (maxTicsPerPixel < 1) {
      pixelsPerTic = maxDistance / ani.duration;
      maxTicsPerPixel = 1;
    }
    else {
      maxTicsPerPixel = Math.ceil(maxTicsPerPixel);
    }

    ani.pixelsPerTic = pixelsPerTic;

    ani.lastTime = new Date().getTime();
    window.requestAnimationFrame(timestamp => { this.pushUpBase(ani, onComplete, timestamp); });
  }

  collectionAniBase(coll, onComplete, timestamp) {
    let numDone = 0;
    const newTime = new Date().getTime();
    if (newTime - coll.lastTime >= 1) {
      const timeDiff = newTime - coll.lastTime;
      coll.lastTime = newTime;
      for (var j = 0; j < coll.collectionValues.length; j++) {
        let ani = coll.collectionValues[j];
        ani.lastTime = newTime;
        ani.pixelsPerTic = coll.pixelsPerTic;
        if (!ani.element) {
          ani.done = true;
        }
        if (ani.done) {
          numDone++;
          continue;
        }
        switch (ani.type) {
        case slide_to:
          if (this.slideToFromBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case slide_from:
          if (this.slideToFromBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case slide_down:
          if (this.slideDownBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case slide_up:
          if (this.slideUpBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case slide_in:
          if (this.slideInBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case slide_out:
          if (this.slideOutBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case push_down:
          if (this.pushDownBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case push_up:
          if (this.pushUpBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        case properties:
          if (this.propertiesBase(ani, null, null, true, timeDiff)) {
            ani.done = true;
            numDone++;
          }
          break;
        default:
          break;
        }
      }
    }
    if (numDone >= coll.collectionValues.length) {
      for (var i = 0; i < coll.collectionValues.length; i++) {
        // var ani = coll.collectionValues[i]
        // if (ani.saveOverflow || ani.saveOverflow == "") {
        //   ani.element.style["overflow-y"] = ani.saveOverflow
        // }
      }
      this.processAnimationQueue(onComplete);
    }
    else {
      window.requestAnimationFrame(timestamp => { this.collectionAniBase(coll, onComplete, timestamp); });
    }
  }

  collectionAni(coll, onComplete, timeStamp) {

    if (coll.length <= 0) {
      this.animationLock = false;
      if (onComplete) {
        onComplete();
      }
    }
    // initialize the colls
    let _this = this;
    let maxDuration = 0;
    let maxDistance = 0;
    for (var i = 0; i < coll.collectionValues.length; i++) {
      let aniColl = coll.collectionValues[i];
      aniColl.element = document.getElementById(aniColl.id);
      // if (aniColl.element && aniColl.element.style && aniColl.element.style["overflow-y"] != "hidden") {
      //   aniColl.saveOverflow = aniColl.element.style["overflow-y"]
      //   aniColl.element.style["overflow-y"] = "hidden"
      // }  

      if (aniColl.secondaryId) {
        aniColl.vertLine = document.getElementById(aniColl.secondaryId);
      }
      if (aniColl.type == properties) {
        const vals = this.initializeProperties(aniColl);
        maxDuration = Math.max(maxDuration, aniColl.duration ? aniColl.duration : 500);
        maxDistance = Math.max(maxDistance, Math.abs(vals.startVal - vals.endVal));
      }
      else {
        aniColl.currentVal = aniColl.startParamValue;
        maxDuration = Math.max(maxDuration, aniColl.duration ? aniColl.duration : 500);
        maxDistance = Math.max(maxDistance, Math.abs(aniColl.currentVal - aniColl.endParamValue));
      }
    }

    // Perform the actual animation

    let pixelsPerTic = 1;
    let maxTicsPerPixel = maxDuration / maxDistance;
    if (maxTicsPerPixel < 1) {
      pixelsPerTic = maxDistance / maxDuration;
      maxTicsPerPixel = 1;
    }
    else {
      maxTicsPerPixel = Math.ceil(maxTicsPerPixel);
    }
    coll.lastTime = new Date().getTime();
    coll.pixelsPerTic = pixelsPerTic;
    window.requestAnimationFrame(timestamp => { this.collectionAniBase(coll, onComplete, timestamp); });

  }

  performAnimation(ani, onComplete) {
    ani.lastTime = new Date().getTime();
    switch (ani.type) {
    case slide_to:
      this.slideTo(ani, onComplete);
      break;
    case slide_from:
      this.slideFrom(ani, onComplete);
      break;
    case slide_down:
      this.slideDown(ani, onComplete);
      break;
    case slide_up:
      this.slideUp(ani, onComplete);
      break;
    case slide_in:
      this.slideIn(ani, onComplete);
      break;
    case slide_out:
      this.slideOut(ani, onComplete);
      break;
    case push_down:
      this.pushDown(ani, onComplete);
      break;
    case push_up:
      this.pushUp(ani, onComplete);
      break;
    case properties:
      this.properties(ani, onComplete);
      break;
    case collection:
      this.collectionAni(ani, onComplete);
      break;
    default:
      break;
    }
  }

  get hasAnimations() {
    return this.animationQueue.length > 0;
  }

  processAnimationQueue(onComplete) {
    if (this.animationQueueIndex < this.animationQueue.length) {
      this.animationLock = true;
      const ani = this.animationQueue[this.animationQueueIndex++];
      this.performAnimation(ani, onComplete);
    }
    else {
      this.animationQueueIndex = 0;
      this.animationQueue = [];
      this.animationLock = false;
      if (onComplete) {
        onComplete();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/helpers/animator.js